<nav aria-label="breadcrumb">
    <ol class="breadcrumb padLeft79">
        <li class="breadcrumb-item active"><a href="/" class="blacktext">Home</a></li>
         <li class="breadcrumb-item" aria-current="page">Cookie Policy</li>
    </ol>
</nav>
<h1 class="cookiePolicyLogout_left_header new_header_cookie">Cookie Policy</h1>
<button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookies Settings</button>
